import { FormControlLabel, Grid, Radio, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import React, { useState } from 'react';
import { DAYS, repeatEndItemList , OnWeekOfList} from '.';
import FuelAutoComplete from '../../fuel-autocomplete';
import RepeatEnd from './RepeatEnd';



const Monthly = ({ form, onFormChange }) => {
  const [selectedRepeat, setSelectedRepeat] = useState({
    id: 'never',
    name: 'Never',
  });
  const [selectedOnWeekOf, setselectedOnWeekOf] = useState(OnWeekOfList[0]);
  const [selectedDay, setSelectedDay] = useState(DAYS[0]);
  
  const handleRepeatChange = (value) => {
    setSelectedRepeat(value);
  };
  const handleOnWeekChange = (value) => {
    setselectedOnWeekOf(value);
    fieldOnChange('rrule.bysetpos', value.id)
  };
  const handleOnDayChange = (value) => {
    setSelectedDay(value);
    fieldOnChange('rrule.byweekday', value.id)
  };

  const fieldOnChange = (field, value) => {
    form.setValue(field, value);
    if (onFormChange) {
      // console.log('update');
      onFormChange(form);
    }
  };

  const handleRadioClick = (e, field)  => {
    form.setValue('monthMode', e.target.value)
    if (e.target.value === 'onMonthDay') {
      form.setValue('rrule.bysetpos', null);
    } else {
      form.setValue('rrule.bymonthday', '')
    }
    onFormChange(form);
  }

  const [untilValue, setUntilValue] = useState(new Date());
  return (
    <>
      <Grid item xs={2}>
        <FormControlLabel  control={<Radio onChange={handleRadioClick} value="onMonthDay" checked={form.getValues('monthMode') === 'onMonthDay'}/>} label="Day" />
      </Grid>
      <Grid item xs={3}>
        <TextField
          variant="outlined"
          type="number"
          InputProps={{
            inputProps: {
              max: 31,
              min: 1,
            },
          }}
          fullWidth
          size="small"
          value={form.getValues('rrule.bymonthday')}
          onChange={(e) => fieldOnChange('rrule.bymonthday', e.target.value)}
        />
      </Grid>
      <RepeatEnd form={form} onFormChange={onFormChange}/>
      <Grid item xs={2}>
        <FormControlLabel
          
          control={<Radio onChange={handleRadioClick} value="onWeek" checked={form.getValues('monthMode') === 'onWeek'}/>}
          label=""
        />
      </Grid>
      <Grid item xs={3}>
      <FuelAutoComplete
              id="repeat-select"
              items={OnWeekOfList}
              itemText="name"
              itemKey="id"
              labelText=""
              placeHolderText=""
              multiSelect={false}
              labelPaddingTop="-5px"
              defaultValue={selectedOnWeekOf}
              onChange={handleOnWeekChange}
            />
      </Grid>
      <Grid item xs={3}>
      <FuelAutoComplete
              id="repeat-select"
              items={DAYS}
              itemText="name"
              itemKey="id"
              labelText=""
              placeHolderText=""
              multiSelect={false}
              labelPaddingTop="-5px"
              onChange={handleOnDayChange}
              defaultValue={selectedDay}
            />
      </Grid>
    </>
  );
};

export default Monthly;
